import { render, staticRenderFns } from "./BoxContainer.vue?vue&type=template&id=189aae92&scoped=true&"
import script from "./BoxContainer.vue?vue&type=script&lang=js&"
export * from "./BoxContainer.vue?vue&type=script&lang=js&"
import style0 from "./BoxContainer.vue?vue&type=style&index=0&id=189aae92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189aae92",
  null
  
)

export default component.exports